<script setup lang="ts">
import { FormField, Select, SelectGroup, SelectOption } from "@soft-db/ui";
import { useGlobalCriterias, useSiteCriterias } from "../../api/vibration-criteria-query";

const criteriaModel = defineModel<string | null>("criteria");

const props = defineProps<{
	site: string;
	required?: boolean;
	label?: string;
}>();

const { t } = useI18n();

const none = { id: null, name: t("common.none") };
const { vibrationCriterias } = useSiteCriterias(() => props.site);
const { globalVibrationCriterias } = useGlobalCriterias();
</script>

<template>
	<FormField :label="props.label ?? t('dashboard.vibrationCriteria')" class="w-full">
		<Select v-model="criteriaModel" class="w-full">
			<SelectGroup v-if="!props.required">
				<SelectOption :value="none.id">{{ none.name }}</SelectOption>
			</SelectGroup>
			<SelectGroup
				v-if="vibrationCriterias.length > 0"
				:label="t('project-settings.siteVibrationCriteria')"
			>
				<SelectOption v-for="vc in vibrationCriterias" :key="vc.id" :value="vc.id">
					{{ vc.name }}
				</SelectOption>
			</SelectGroup>
			<SelectGroup
				v-if="globalVibrationCriterias.length > 0"
				:label="t('project-settings.globalVibrationCriteria')"
			>
				<SelectOption v-for="vc in globalVibrationCriterias" :key="vc.id" :value="vc.id">
					{{ vc.name }}
				</SelectOption>
			</SelectGroup>
		</Select>
	</FormField>
</template>
